export default __webpack_public_path__ + "static/media/bt.547fadb6.jpg";